import config from '../../config';
import { Tile, TilePool } from './Tiles';
import TileMatch from './TileMatch';
import OpenAllBoxes from './OpenAllBoxes';

// const TILE_WIDTH = config.TILE_WIDTH;
// const TILE_HEIGHT = config.TILE_HEIGHT;
const TILE_WIDTH = 84;
const TILE_HEIGHT = 114;
const BORDER_WIDTH = 14;
const BORDER_HEIGHT = 10;

let soundManager;
let dataManager;

let hitRect = new Phaser.Geom.Rectangle(14, 22, 81, 111);
let rectTest = (shape, x, y, gameObject) => {
  return (x >= shape.x && x <= shape.x + shape.width) && (y >= shape.y && y <= shape.y + shape.height);
};

let collectables = [];

class Mahjong {
  constructor (g, layout, replay) {
    this.g = g;

    if (!soundManager) {
      soundManager = g.scene.get('SoundManager');
      dataManager = g.sys.game.dataManager;
    }

    // frames are all of the available options for a Tile to use as its graphical identity
    this.frames = g.cache.json.get('tiles-closed').textures[0].frames;
    // console.log('sprite frames', this.frames);
    // layout is an array of arrays representing the board layout in 0s and 1s
    // it holds no value as to what each tiles identity is, only serves as a blueprint for where they go
    this.layout = layout;
    // the board array will be used to keep track of the tiles in the same data structure as the layout
    // instead of 0s and 1s it will hold null and Tile objects
    this.board = [];
    // the tiles array is just a flat array that contains a reference to each Tile object
    this.tiles = [];
    // completedMoves is an array of arrays
    // each sub array contains the two Tile objects that represet the completed move
    this.completedMoves = [];
    this.maxCols = layout[0][0].length - 1;
    this.maxRows = layout[0].length - 1;
    this.maxLayers = layout.length - 1;
    this.bearsFound = [];
    this.collectableFound = 0;
    if (replay) {
      this.bearsFound = replay.bearsFound;
      this.collectableFound = replay.collectableFound;
    }

    // collectables get saved across games
    // if the collectables array is empty, re populate
    if (collectables.length === 0) {
      collectables = _.reduce(g.cache.json.get('collectables').textures[0].frames, (result, value, key) => {
        result.push(value.filename);
        return result;
      }, []);

      // start optional logic for FindersKeepers achievement
      // let collectableState = dataManager.getItem('collectables');
      // if (collectableState.length < config.COLLECTABLE_TOTAL) {
      //   _.each(collectableState, (c) => {
      //     let cI = collectables.indexOf(c);
      //     if (cI > -1) {
      //       collectables.splice(cI, 1);
      //     }
      //   });
      // }
      // end optional logic for FindersKeepers achievement

      collectables = _.shuffle(collectables);
      console.log('collectables populated', collectables);
    }

    // user selected tile
    this.selectedTile = null;

    // our first method used in creating our Mahjong game
    // writeLayout uses the layout blueprint to calculate each Tiles x, y, and z position
    // the cordinates are then used to create and place the Tile on screen
    // Each Tile is tracked in the board data structure and tiles array
    this.writeLayout();
    if (this.tiles.length % 4 !== 0) {
      // TODO add replay check
      console.warn('The number of tiles are not divisible by 4');
      // return;
    }
    if (this.tiles.length < 16) {
      // TODO add replay check
      console.warn('Board layouts cannot have less than 16 tiles');
      // return;
    }
    // loop through our board layout and assign identites to our tiles in a way that is solvable
    this.shuffleTiles();
    // tile interaction logic
    this.setListeners();
    // revealTiles is an animated intro sequence to reveal our board
    this.revealTiles(() => {
      // not sure I need this? remove this callback for now
      // this.checkBoard();
    });

    // console.log('New Mahjong', this);
  }
  removeListeners () {
    let g = this.g;
    _.each(this.tiles, (tile) => {
      tile.sprite.off('pointerdown');
    });
  }
  setListeners () {
    let g = this.g;
    _.each(this.tiles, (tile) => {
      tile.sprite.off('pointerdown');
      tile.setCold();
    });
    _.each(this.tiles, (tile) => {
      if (tile.isActive && this.tileIsFree(tile.id)) {
        tile.setHot();
        tile.sprite.on('pointerdown', () => {
          let frameName = tile.sprite.frame.name;
          if (!this.selectedTile) {
            // SELECT TILE
            this.selectedTile = tile;
            tile.bracket.play('bracket-select');
          } else if (this.selectedTile === tile) {
            // DESELECT TILE
            this.selectedTile = null;
            tile.bracket.play('bracket-hidden');
          } else if (frameName === this.selectedTile.sprite.frame.name) {
            // TILE MATCH FEEDBACK

            g.countTileMatch();
            TileMatch.call(this, tile, this.selectedTile);
            this.completedMoves.push([tile, this.selectedTile]);
            g.powerUpButtonCheck();

            // END TILE MATCH FEEDBACK
          } else {
            // TILE MISMATCH FEEDBACK

            let tileA = tile;
            let tileB = this.selectedTile;
            let tileAFreeLeft = this.tileIsFreeLeft(tileA.id);
            let tileAFreeRight = this.tileIsFreeRight(tileA.id);
            let tileAFreeBoth = tileAFreeLeft && tileAFreeRight;
            let tileBFreeLeft = this.tileIsFreeLeft(tileB.id);
            let tileBFreeRight = this.tileIsFreeRight(tileB.id);
            let tileBFreeBoth = tileBFreeLeft && tileBFreeRight;
            let Ax, Bx;
            let x = 6;

            if (tileAFreeBoth && tileBFreeBoth) {
              Ax = x;
              Bx = -x;
            } else if (tileAFreeBoth && !tileBFreeBoth) {
              Ax = tileBFreeRight ? -x : x;
              Bx = tileBFreeRight ? x : -x;
            } else if (!tileAFreeBoth && tileBFreeBoth) {
              Ax = tileAFreeRight ? x : -x;
              Bx = tileAFreeRight ? -x : x;
            } else {
              Ax = tileAFreeRight ? x : -x;
              Bx = tileBFreeRight ? x : -x;
            }

            this.selectedTile = null;

            tileA.bracket.play('bracket-no-match');
            tileB.bracket.play('bracket-no-match');

            g.tweens.add({
              targets: [tileA.sprite, tileA.bracket],
              x: '+=' + Ax,
              duration: 100,
              repeat: 1,
              yoyo: true
            });

            g.tweens.add({
              targets: [tileB.sprite, tileB.bracket],
              x: '+=' + Bx,
              duration: 100,
              repeat: 1,
              yoyo: true
            });

            g.time.delayedCall(450, () => {
              // DESELECT BOTH TILES
              tileA.bracket.play('bracket-hidden');
              tileB.bracket.play('bracket-hidden');
            });

            soundManager.playSound('no-match');
          }
        });
      }
    });
  }
  isHintAvailable () {
    let freeTiles = [];
    let hintFound = false;

    // check if there any matches to be made
    _.each(this.tiles, tile => {
      if (tile.isActive && this.tileIsFree(tile.id) && !tile.isHint) {
        freeTiles.push(tile);
      }
    });
    _.reverse(freeTiles);

    for (let tileA of freeTiles) {
      for (let tileB of freeTiles) {
        if (tileA.id !== tileB.id) {
          if (tileA.sprite.frame.name === tileB.sprite.frame.name) {
            hintFound = true;
            break;
          }
        }
      }
      if (hintFound) { break; }
    }

    return hintFound;
  }
  getHint () {
    let g = this.g;
    let freeTiles = [];
    let hintFound = false;

    // check if there any matches to be made
    _.each(this.tiles, tile => {
      if (tile.isActive && this.tileIsFree(tile.id) && !tile.isHint) {
        freeTiles.push(tile);
      }
    });
    _.reverse(freeTiles);

    for (let tileA of freeTiles) {
      for (let tileB of freeTiles) {
        if (tileA.id !== tileB.id) {
          if (tileA.sprite.frame.name === tileB.sprite.frame.name) {
            hintFound = true;
            tileA.isHint = true;
            tileB.isHint = true;
            // start hint tween

            let x = 3;
            let Ax, Bx;
            let tileAFreeLeft = this.tileIsFreeLeft(tileA.id);
            let tileAFreeRight = this.tileIsFreeRight(tileA.id);
            let tileAFreeBoth = tileAFreeLeft && tileAFreeRight;
            let tileBFreeLeft = this.tileIsFreeLeft(tileB.id);
            let tileBFreeRight = this.tileIsFreeRight(tileB.id);
            let tileBFreeBoth = tileBFreeLeft && tileBFreeRight;

            if (tileAFreeBoth && tileBFreeBoth) {
              Ax = x;
              Bx = -x;
            } else if (tileAFreeBoth && !tileBFreeBoth) {
              Ax = tileBFreeRight ? -x : x;
              Bx = tileBFreeRight ? x : -x;
            } else if (!tileAFreeBoth && tileBFreeBoth) {
              Ax = tileAFreeRight ? x : -x;
              Bx = tileAFreeRight ? -x : x;
            } else {
              Ax = tileAFreeRight ? x : -x;
              Bx = tileBFreeRight ? x : -x;
            }

            tileA.tween = g.tweens.add({
              targets: [tileA.sprite, tileA.bracket],
              x: '+=' + Ax,
              duration: 300,
              repeat: -1,
              yoyo: true
            });

            tileB.tween = g.tweens.add({
              targets: [tileB.sprite, tileB.bracket],
              x: '+=' + Bx,
              duration: 300,
              repeat: -1,
              yoyo: true
            });

            // old hint tween
            // tileA.tween = g.tweens.add({
            //   targets: [tileA.sprite, tileB.sprite, tileA.bracket, tileB.bracket],
            //   scaleX: 0.8,
            //   scaleY: 0.8,
            //   duration: 500,
            //   repeat: -1,
            //   yoyo: true
            // });

            // end tween hint
            break;
          }
        }
      }
      if (hintFound) { break; }
    }

    if (!hintFound) {
      console.warn('No hints available, button should be disabled');
    }
  }
  getBearHint () {
    let g = this.g;

    let bearTiles = [];

    bearTiles = _.filter(this.tiles, (tile) => {
      return tile.isActive && this.tileIsFree(tile.id) && tile.bearType !== null;
    });

    if (bearTiles.length === 0) {
      bearTiles = _.filter(this.tiles, (tile) => {
        return tile.isActive && tile.bearType !== null;
      });
    }

    if (bearTiles.length) {
      bearTiles = _.shuffle(bearTiles);
      let tile = bearTiles.pop();
      let timeline = g.tweens.createTimeline();
      timeline.add({
        targets: tile.sprite,
        angle: -3,
        duration: 100
      });
      timeline.add({
        targets: tile.sprite,
        angle: 6,
        duration: 100,
        yoyo: true,
        repeat: 2
      });
      timeline.add({
        targets: tile.sprite,
        angle: 0,
        duration: 100
      });
      timeline.play();
    }
  }
  countRemainingTiles () {
    let g = this.g;
    let count = 0;
    _.each(this.tiles, tile => {
      if (tile.isActive) {
        count++;
      }
    });
    return count++;
  }
  checkBoard () {
    let g = this.g;
    let freeTiles = [];

    let remainingTiles = _.reverse(_.filter(this.tiles, 'isActive'));
    if (remainingTiles.length === 0) {
      g.showBoardCleared();
      return;
    }

    // TODO: CHECK IF WE FOUND ALL BEARS
    if (this.bearsFound.length === 3) {
      OpenAllBoxes.call(this, () => {
        g.showBoardCleared(true);
      }, true);
      return;
    }

    // kill previous tweens // why ?
    // _.each(this.tiles, tile => {
    //   if (tile.tween) {
    //     tile.tween.stop();
    //     tile.tween = null;
    //   }
    //   tile.sprite.setScale(1);
    //   tile.bracket.setScale(1);
    // });

    // check if there are any tiles active
    let activeTiles = _.filter(this.tiles, (t) => { return t.isActive; });
    if (activeTiles.length === 0) {
      // Show boxes cleared messaging
      g.showBoardCleared();
      return;
    }

    // check if there any matches to be made
    _.each(this.tiles, tile => {
      if (tile.isActive && this.tileIsFree(tile.id)) {
        freeTiles.push(tile);
      }
    });
    _.reverse(freeTiles);

    let matchAvailable = false;
    for (let tileA of freeTiles) {
      for (let tileB of freeTiles) {
        if (tileA.id !== tileB.id) {
          if (tileA.sprite.frame.name === tileB.sprite.frame.name) {
            // console.log('Match!', tileA.id, tileB.id);
            matchAvailable = true;
            break;
          }
        }
      }
      if (matchAvailable) { break; }
    }

    if (!matchAvailable) {
      // Show reshuffle option
      g.onNoMovesLeft();
      return;
    }

    // start for dev only
    // if (this.isHintAvailable()) {
    //   this.getHint();
    // }
    // end for dev only

    this.setListeners();
    g.powerUpButtonCheck();
  }
  writeLayout () {
    let g = this.g;
    let layout = this.layout;
    let board = this.board;
    let maxRows = this.maxRows;
    let maxCols = this.maxCols;
    let ofsH = (TILE_WIDTH - BORDER_WIDTH) / 2;
    let ofsV = (TILE_HEIGHT - BORDER_HEIGHT) / 2;
    let boardWidth = ofsH * maxCols + TILE_WIDTH;
    let boardHeight = ofsV * maxRows + TILE_HEIGHT;
    let boardPaddingLeft = (config.WIDTH - boardWidth) / 2 + TILE_WIDTH / 2;
    let boardPaddingTop = (config.HEIGHT - boardHeight) / 2 + TILE_HEIGHT / 2;
    let z = 0;
    // console.log(board);
    // loop through each layer of the layout
    for (let l = 0; l < layout.length; l++) {
      z++; // layer z index
      let layer = layout[l];
      let ofsZY = l * (BORDER_HEIGHT - 1);
      let ofsZX = l * (BORDER_WIDTH - 1);
      // create a new layer in our board array
      board[l] = [];
      // board layer
      let bl = board[l];
      // loop through each layer row
      for (let r = 0; r < layer.length; r++) {
        let ofsY = ofsV * r - ofsZY;
        let row = layer[r];
        // create a new row in our board layer array
        bl[r] = [];
        // board row
        let br = bl[r];
        // loop through each column plot in our row
        for (let c = row.length - 1; c >= 0; c--) {
          // if the column plot is occupied
          if (row[c]) {
            let inverseC = row.length - c;
            // console.log(`Tile row:${r} column:${inverseC}`);
            let layerIndexScore = r + inverseC;
            // console.log('zIndex Score', layerIndexScore);
            // create a new tile
            let ofsX = ofsH * c + ofsZX;
            let tile = new Tile();
            tile.x = boardPaddingLeft + ofsX;
            tile.y = boardPaddingTop + ofsY;
            tile.sprite = g.add.sprite(tile.x, tile.y, 'tiles-closed');
            tile.sprite.setInteractive(hitRect, rectTest);
            tile.sprite.setScale(0);
            tile.bracket = g.add.sprite(tile.x, tile.y, 'bracket');
            tile.id = { l, r, c };
            tile.isActive = true;
            tile.layerIndexScore = layerIndexScore;
            tile.layerIndex = z;
            this.tiles.push(tile);
            br[c] = tile;
          } else {
            br[c] = null;
          }
        }
      }
    }
    let tilesToZIndex = _.sortBy(_.clone(this.tiles), ['layerIndex', 'layerIndexScore']);
    _.each(tilesToZIndex, (tile) => {
      g.children.bringToTop(tile.sprite);
      g.children.bringToTop(tile.bracket);
    });
  }
  undoMove () {
    let g = this.g;
    if (this.completedMoves.length === 0) {
      console.warn('No Moves to undo, button should be disabled');
      return;
    }
    this.removeListeners();
    let pair = this.completedMoves.pop();
    let tileA = pair.pop();
    let tileB = pair.pop();
    tileA.bearType = null;
    tileA.collectableType = null;
    tileA.sprite.setScale(0);
    tileA.sprite.setAlpha(1);
    tileA.sprite.setPosition(tileA.x, tileA.y);
    tileA.isActive = true;
    tileB.bearType = null;
    tileB.collectableType = null;
    tileB.sprite.setScale(0);
    tileB.sprite.setAlpha(1);
    tileB.sprite.setPosition(tileB.x, tileB.y);
    tileB.isActive = true;
    g.children.bringToTop(tileA.poof);
    g.children.bringToTop(tileB.poof);
    tileA.poof.play('play-poof-animate');
    tileB.poof.play('play-poof-animate');
    g.tweens.add({
      targets: [tileA.sprite, tileB.sprite],
      scaleX: 1,
      scaleY: 1,
      duration: 250,
      onComplete: () => {
        this.checkBoard();
      }
    });
  }
  silentUndo () {
    if (this.completedMoves.length === 0) {
      return;
    }
    let pair = this.completedMoves.pop();
    let tileA = pair.pop();
    let tileB = pair.pop();
    tileA.isActive = true;
    tileB.isActive = true;
  }
  useBomb () {
    let g = this.g;
    // Add some kind of bomb feedback
    OpenAllBoxes.call(this, () => {
      g.showBoardCleared();
    });
  }
  revealTiles (cb) {
    let g = this.g;
    // poof
    let shuffledTiles = _.shuffle(_.clone(this.tiles));
    _.each(shuffledTiles, (tile, i) => {
      tile.poof = g.add.sprite(tile.sprite.x, tile.sprite.y - 40, 'play-poof');
      tile.poof.setVisible(false);
      if (i % 2 === 0) {
        tile.poofOnReveal = true;
      }
    });
    shuffledTiles.length = 0;
    _.each(this.tiles, (tile, i) => {
      g.time.delayedCall(i * 10, () => {
        if (tile.poofOnReveal) {
          tile.poof.play('play-poof-animate');
        }
        tile.tween = g.tweens.add({
          targets: [tile.sprite],
          scaleX: 1,
          scaleY: 1,
          duration: 250,
          onComplete: () => {
            if (i + 1 === this.tiles.length) {
              if (cb) {
                cb();
              }
            }
          }
        });
      });
    });
  }
  shuffleTiles (count = 0) {
    let g = this.g;
    // TilePool generates a random pool that only contains a quarter as many frames as we need to fill the board
    // this will ensure the 4 tile 2 set match rule
    let tilePool = new TilePool(this.frames, this.tiles.length);
    // sequence keeps track of the Tiles in the order they are layed out (flat array)
    let sequence = [];
    // while creating the sequence array
    // we hold all the freeTiles together so we can randomly select two tiles to assign the tile pool frame
    let freeTiles = [];
    // a flag for if we need to restart the sequence process
    let reShuffle = false;
    // keeps track of the tile pairs as they are layed out (array of arrays)
    let pairs = [];

    // console.log('frames', this.frames);
    // console.log('tiles', this.tiles);

    // populate our board by adding pairs from the top down
    while (sequence.length < this.tiles.length) {
      freeTiles.length = 0;
      // collect all playable tiles
      _.each(this.tiles, (tile) => {
        if (tile.isActive && this.tileIsFree(tile.id)) {
          freeTiles.push(tile);
        }
      });
      // if there are less than two tiles playable, we've hit a dead end and need to reshuffle
      if (freeTiles.length < 2) {
        // console.log('ReShuffle!', count);
        count++;
        reShuffle = true;
        break;
      }
      // randomize the freeTiles
      freeTiles = _.shuffle(freeTiles);
      // pick one frame to assign to two of the playable tiles
      let frame = tilePool.getTileFrame();
      // remove two tiles from the free tiles array and assign their values
      let tileA = freeTiles.pop();
      let tileB = freeTiles.pop();
      tileA.sprite.setFrame(frame);
      tileB.sprite.setFrame(frame);
      tileA.isActive = false;
      tileB.isActive = false;
      // add these tiles to our sequence
      sequence.push(tileA);
      sequence.push(tileB);
      // keep track of the original pairs
      pairs.push([tileA, tileB]);
    }

    // after asigning all of our tiles a frame, turn them all back on
    _.each(this.tiles, (tile) => {
      tile.isActive = true;
    });
    // infinite reshuffle catch, probably from a bad level layout
    if (reShuffle) {
      if (count >= 100) {
        console.warn('infinite shuffle loop! level json layout is broken');
        g.scene.start('Score');
        return;
      }
      this.shuffleTiles(count);
      return;
    }

    // use the pairs array to assign hidden bears and collectables
    pairs = _.shuffle(pairs);
    // let bears = _.clone(config.BEARS);
    let bears = [];
    _.each(config.BEARS, (b) => {
      if (this.bearsFound.indexOf(b) === -1) {
        bears.push(b);
      }
    });
    // console.log('bears to be found', bears);
    // to avoid having a match containing two collectable items, we will keep track of what frame types have been used
    let usedFrames = [];
    while (bears.length) {
      if (pairs.length === 0) {
        console.warn('Bear assignment error');
        return;
      }
      let pair = pairs.pop();
      let frameName = pair[0].sprite.frame.name;
      if (usedFrames.indexOf(frameName) === -1) {
        let bear = bears.pop();
        usedFrames.push(frameName);
        pair[0].bearType = bear;
      }
    }
    if (this.collectableFound === 0) {
      let collectableAssigned = false;
      while (!collectableAssigned) {
        if (pairs.length === 0) {
          console.warn('Collectable assignment error');
          return;
        }
        let pair = pairs.pop();
        let frameName = pair[0].sprite.frame.name;
        if (usedFrames.indexOf(frameName) === -1) {
          let c = collectables.pop();
          pair[0].collectableType = c;
          collectableAssigned = true;
          console.log('collectable assigned', c);
        }
      }
    } else {
      console.log('Replay collectable already found');
    }

    pairs.length = 0;
  }
  getTileId (l, r, c) {
    return '_' + l + '_' + r + '_' + c;
  }
  tileIsFree (tileId) {
    return ((this.tileIsFreeAbove(tileId)) && ((this.tileIsFreeLeft(tileId)) || (this.tileIsFreeRight(tileId))));
  }
  tileIsFreeAbove ({ l, r, c }) {
    let maxLayers = this.maxLayers;
    let maxRows = this.maxRows;
    let maxCols = this.maxCols;
    let board = this.board;
    l++;
    if ((l > maxLayers) || (r === 0) || (r === maxRows) || (c === 0) || (c === maxCols)) return true;
    for (let ri = r - 1; ri <= r + 1; ri++) {
      for (let ci = c - 1; ci <= c + 1; ci++) {
        let tile = board[l][ri][ci];
        if (tile && tile.isActive) return false;
      }
    }
    return true;
  }
  tileIsFreeTop ({ l, r, c }) {
    let maxCols = this.maxCols;
    let board = this.board;
    r -= 2;
    if ((r < 0) || (c === 0) || (c === maxCols)) return true;
    for (let ci = c - 1; ci <= c + 1; ci++) {
      let tile = board[l][r][ci];
      if (tile && tile.isActive) return false;
    }
    return true;
  }
  tileIsFreeBottom ({ l, r, c }) {
    let maxRows = this.maxRows;
    let maxCols = this.maxCols;
    let board = this.board;
    r += 2;
    if ((r > maxRows) || (c === 0) || (c === maxCols)) return true;
    for (let ci = c - 1; ci <= c + 1; ci++) {
      let tile = board[l][r][ci];
      if (tile && tile.isActive) return false;
    }
    return true;
  }
  tileIsFreeLeft ({ l, r, c }) {
    let maxRows = this.maxRows;
    let board = this.board;
    c -= 2;
    if ((c < 0) || (r === 0) || (r === maxRows)) return true;
    for (let ri = r - 1; ri <= r + 1; ri++) {
      let tile = board[l][ri][c];
      if (tile && tile.isActive) return false;
    }
    return true;
  }
  tileIsFreeRight ({ l, r, c }) {
    let maxRows = this.maxRows;
    let maxCols = this.maxCols;
    let board = this.board;
    c += 2;
    if ((c > maxCols) || (r === 0) || (r === maxRows)) return true;
    for (let ri = r - 1; ri <= r + 1; ri++) {
      let tile = board[l][ri][c];
      if (tile && tile.isActive) return false;
    }
    return true;
  }
}

export default Mahjong;
